import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  userToEdit: {
    idBank: '',
    corporateSenderId: '',
    fullName: '',
    description: '',
    enabled: true,
    username: '',
    phone: '',
    email:'',
    reset: true,
    password: '',
    role: '',
    corporateName:'',
    bankName:'',
    language:'',
    userCorporates:'',
    reportSection: true,
    distinteSection: true
  },
  allUserCorporates:[],
  permissionList:[],
  error: ''
}

export default function userEdit(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_USER_EDIT_SUCCESS:
      return fetchUserEditSuccess(state, action)
    case actions.FETCH_USER_EDIT_FAILURE:
      return fetchUserEditFailure(state, action)
    case actions.EDIT_USER_ID_BANK_FIELD_CHANGE:
      return editUserIdBankFieldChange(state, action)
    case actions.EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE:
      return editUserCorporateSenderIdFieldChange(state, action)
    case actions.EDIT_USER_FULL_NAME_FIELD_CHANGE:
      return editUserFullNameFieldChange(state, action)
    case actions.EDIT_USER_DESCRIPTION_FIELD_CHANGE:
      return editUserDescriptionFieldChange(state, action)
    case actions.EDIT_USER_ENABLED_FIELD_CHANGE:
      return editUserEnabledFieldChange(state, action)
    case actions.EDIT_USER_USERNAME_FIELD_CHANGE:
      return editUserUsernameFieldChange(state, action)
    case actions.EDIT_USER_PHONE_FIELD_CHANGE:
      return editUserPhoneFieldChange(state, action)
    case actions.EDIT_USER_EMAIL_FIELD_CHANGE:
      return editUserEmailFieldChange(state, action)
    case actions.EDIT_USER_RESET_FIELD_CHANGE:
      return editUserResetFieldChange(state, action)
    case actions.EDIT_USER_PASSWORD_FIELD_CHANGE:
      return editUserPasswordFieldChange(state, action)
    case actions.EDIT_USER_REPORT_SECTION_FIELD_CHANGE:
      return editUserReportSectionFieldChange(state, action)
    case actions.EDIT_USER_DISTINTE_SECTION_FIELD_CHANGE:
      return editUserDistinteSectionFieldChange(state, action)
    case actions.EDIT_USER_ROLE_FIELD_CHANGE:
      return editUserRoleFieldChange(state, action)
    case actions.EDIT_USER_LANGUAGE_FIELD_CHANGE:
      return editUserLanguageFieldChange(state, action)
    case actions.EDIT_USER_CORPORATE_PERMISSION_CHANGE:
      return editUserCorporatePermissionChange(state, action)
    case actions.EDIT_USER_CORPORATE_PERMISSION_LIST:
      return editUserCorporatePermissionList(state, action)
    case actions.FETCH_USER_CORPORATES_SUCCESS:
      return updateUserCorporateList(state, action)
    case actions.EDIT_USER_CLEAN:
      return editUserClean(state, action)
    case actions.UPDATE_USER_EDIT_FAILURE:
      return editUserUpdateFailure(state,action)
    default:
      return state
  }
}

const editUserUpdateFailure = (state,action) =>{

  return {
    ...state,
    error: action.error
  }
}

const fetchUserEditSuccess = (state, action) => {
  return {
    ...state,
    userToEdit: action.value
  }
}

const fetchUserEditFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const editUserIdBankFieldChange = (state, action) => {
  let bankId=action.value.split(":")[0]
  let bankName=action.value.split(":")[1]
  return update(
    state,
    {userToEdit: {idBank: {$set: bankId},bankName:{$set: bankName}}}
    )
}

const editUserCorporateSenderIdFieldChange = (state, action) => {
  let corporateId=action.value.split(":")[0]
  let corporateName=action.value.split(":")[1]
  return update(
    state,
    {userToEdit: {corporateSenderId: {$set: corporateId},corporateName:{$set: corporateName}}}
  )
}

const editUserFullNameFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {fullName: {$set: action.value}}}
  )
}

const editUserLanguageFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {language: {$set: action.value}}}
  )
}

const editUserReportSectionFieldChange = (state, action) => {
  return update(
      state,
      {userToEdit: {reportSection: {$set: action.value}}}
  )
}

const editUserDistinteSectionFieldChange = (state, action) => {
  return update(
      state,
      {userToEdit: {distinteSection: {$set: action.value}}}
  )
}

const editUserCorporatePermissionChange = (state, action) => {
  return update(
      state,
      {userToEdit: {userCorporates: {$set: action.value}}}
  )
}

function checkUserCorporate(senderId,allUserCorporates){
  let response=false;
  if(undefined !== allUserCorporates){
    allUserCorporates.map((item)=>{
      if(item===senderId){
        response=true;
      }
    })
  }
  return response;
}




const updateUserCorporateList = (state, action) => {
  var permissionList=[];

  action.value.corporates.map((item)=>{
    // if(this.props.userCorporates.length>0){
    if(checkUserCorporate(item.corporateSenderId,action.value.allCorporates) === true){
      var corporate={
        corporateSenderName:item.corporateSenderName,
        corporateSenderId:item.corporateSenderId,
        read:false,
        write:false
      }
      permissionList.push(corporate)
    }
    // }
  })
  let finalList=[];
  if(state.userToEdit.userCorporates.length>0){
    // permissionList=permissionList.
    state.userToEdit.userCorporates.map((userCorp)=>{
      finalList=permissionList.map((corporatePerm)=>{
        if(corporatePerm.corporateSenderId===userCorp.corporateSenderId){
          corporatePerm.read=userCorp.read;
          corporatePerm.write=userCorp.write;
          // finalList.push(corporatePerm);
          return corporatePerm

        }else{

          // finalList.push(corporatePerm);
          return corporatePerm
        }
      })
    })
  }else{

    finalList=permissionList;

  }
  return update(
      state,
      {allUserCorporates: {$set: action.value.allUserCorporates},permissionList:{$set:finalList}}
  )
}
const editUserCorporatePermissionList = (state, action) => {
  return update(
      state,
      {permissionList: {$set: action.value}}
  )
}
const editUserDescriptionFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {description: {$set: action.value}}}
  )
}

const editUserEnabledFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {enabled: {$set: action.value}}}
  )
}

const editUserUsernameFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {username: {$set: action.value}}}
  )
}

const editUserPhoneFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {phone: {$set: action.value}}}
  )
}

const editUserEmailFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {email: {$set: action.value}}}
  )
}

const editUserResetFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {reset: {$set: action.value}}}
  )
}

const editUserPasswordFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {password: {$set: action.value}}}
  )
}

const editUserRoleFieldChange = (state, action) => {
  return update(
    state,
    {userToEdit: {role: {$set: action.value}}}
  )
}

const editUserClean = (state, action) => {
  return initialState;
}